import businessGoldIcon from "shared/images/icons/plans/business-gold.svg"
import businessPlatinumIcon from "shared/images/icons/plans/business-platinum.svg"
import businessIcon from "shared/images/icons/plans/business.svg"
import performanceGoldIcon from "shared/images/icons/plans/performance-gold.svg"
import performancePlatinumIcon from "shared/images/icons/plans/performance-platinum.svg"
import performanceIcon from "shared/images/icons/plans/performance.svg"
import starterIcon from "shared/images/icons/plans/starter.svg"

export const PlanNames = {
  StarterMonthly: "Starter - Monthly",
  BusinessMonthly: "Business - Monthly",
  BusinessGoldMonthly: "Business Gold - Monthly",
  BusinessPlatinumMonthly: "Business Platinum - Monthly",
  BusinessYearly: "Business - Yearly",
  Performance: "Performance",
  PerformanceGold: "Performance Gold",
  PerformancePlatinum: "Performance Platinum",
}

export const plansOrder = {
  monthly: [
    PlanNames.StarterMonthly,
    PlanNames.BusinessMonthly,
    PlanNames.BusinessGoldMonthly,
    PlanNames.BusinessPlatinumMonthly,
  ],
  yearly: [PlanNames.BusinessYearly],
  domestic: [
    PlanNames.Performance,
    PlanNames.PerformanceGold,
    PlanNames.PerformancePlatinum,
  ],
}

export const availablePlans = [
  {
    name: PlanNames.StarterMonthly,
    type: "international",
    icon: starterIcon,
    description: "Test your international potential",
  },
  {
    name: PlanNames.BusinessMonthly,
    type: "international",
    icon: businessIcon,
    description: "Optimize your spend for frequent transactions",
  },
  {
    name: PlanNames.BusinessGoldMonthly,
    type: "international",
    icon: businessGoldIcon,
    description:
      "Reach new heights with gold-tier savings and account management",
  },
  {
    name: PlanNames.BusinessPlatinumMonthly,
    type: "international",
    icon: businessPlatinumIcon,
    description:
      "Reach new heights with platinum-tier savings and account management",
  },
  {
    name: PlanNames.BusinessYearly,
    type: "international",
    icon: businessIcon,
    description: "Optimize your spend for frequent transactions",
  },
  {
    name: PlanNames.Performance,
    type: "domestic",
    icon: performanceIcon,
    description: "Beat your local competition",
  },
  {
    name: PlanNames.PerformanceGold,
    type: "domestic",
    icon: performanceGoldIcon,
    description: "Reach new heights with gold-tier savings",
  },
  {
    name: PlanNames.PerformancePlatinum,
    type: "domestic",
    icon: performancePlatinumIcon,
    description:
      "Reach new heights with platinum-tier savings and account management",
  },
]

export const getPlanData = (name, type) => {
  const plan = availablePlans.find(p => p.name === name && p.type === type)

  if (plan) {
    return {
      description: plan.description,
      icon: plan.icon,
    }
  }

  return {
    icon: businessIcon,
    description: "Optimize your spend for frequent transactions",
  }
}
